
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  BookOpen, 
  Home, 
  Settings, 
  User,
  FileText
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const PressSidebar: React.FC = () => {
  const location = useLocation();
  const { profile } = useAuth();

  const navigationItems = [
    {
      title: 'Dashboard',
      href: '/press-dashboard',
      icon: Home,
    },
    {
      title: 'Articles',
      href: '/press-dashboard/articles',
      icon: BookOpen,
    },
    {
      title: 'Profile',
      href: '/press-dashboard/profile',
      icon: User,
    },
    {
      title: 'Settings',
      href: '/press-dashboard/settings',
      icon: Settings,
    },
  ];

  return (
    <div className="fixed left-0 top-0 z-40 h-screen w-64 bg-white border-r border-gray-200 shadow-sm">
      <div className="flex h-full flex-col">
        {/* Header */}
        <div className="flex h-16 items-center border-b border-gray-200 px-6">
          <h2 className="text-lg font-semibold text-gray-900">Press Dashboard</h2>
        </div>

        {/* User Info */}
        <div className="border-b border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {profile?.name?.charAt(0) || 'U'}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">{profile?.name}</p>
              <p className="text-xs text-gray-500">Press Member</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 p-4">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href;
            
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center space-x-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <Icon className="h-5 w-5" />
                <span>{item.title}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default PressSidebar;
